<template>
  <crud-layout :title="title" :subtitle="subtitle">
    <template v-slot:list>
      <cash-register-list
          ref="list"
          @update="update"
          @delete="remove"
          @show="show"
      />
    </template>

    <add-button v-if="$store.getters.hasPermission('CASHREGISTER_CREATE')" @click="create"></add-button>

    <cash-register-create
        v-if="creating"
        :open="creating"
        v-on:itemCreated="onItemCreated"
        v-on:close="creating=false"
    />

    <cash-register-update
        v-if="updating"
        :open="updating"
        :item="itemToEdit"
        v-on:itemUpdated="onItemUpdated"
        v-on:close="updating=false"
    />

    <cash-register-show
        v-if="showing"
        :open="showing"
        :item="itemToShow"
        v-on:close="showing=false"
    />

    <cash-register-delete
        v-if="deleting"
        :open="deleting"
        :item="itemToDelete"
        v-on:itemDeleted="onItemDeleted"
        v-on:close="deleting=false"
    />

    <snackbar v-model="flash"/>
  </crud-layout>
</template>

<script>
import CashRegisterCreate from "./CashRegisterCreate";
import CashRegisterUpdate from "./CashRegisterUpdate";
import CashRegisterDelete from "./CashRegisterDelete";
import CashRegisterShow from "./CashRegisterShow";
import CashRegisterList from "./CashRegisterList";
import {CrudLayout, AddButton, Snackbar} from "@dracul/common-frontend"

export default {
  name: "CashRegisterCrudPage",
  components: {
    CrudLayout, AddButton, Snackbar,
    CashRegisterCreate,
    CashRegisterUpdate,
    CashRegisterDelete,
    CashRegisterShow,
    CashRegisterList
  },
  data() {
    return {
      title: 'delivery.cashRegister.title',
      subtitle: 'delivery.cashRegister.subtitle',
      flash: null,
      creating: false,
      updating: false,
      deleting: false,
      showing: false,
      itemToEdit: null,
      itemToDelete: null,
      itemToShow: null,
    }
  },
  methods: {
    onItemCreated() {
      this.$refs.list.fetch()
      this.flash = this.$t("common.created")
    },
    onItemUpdated() {
      this.$refs.list.fetch()
      this.flash = this.$t("common.updated")
    },
    onItemDeleted() {
      this.$refs.list.fetch()
      this.flash = this.$t("common.deleted")
    },
    create() {
      this.creating = true
    },
    update(item) {
      this.updating = true
      this.itemToEdit = item
    },
    show(item) {
      this.showing = true
      this.itemToShow = item
    },
    remove(item) {
      this.deleting = true
      this.itemToDelete = item
    }
  }
}
</script>
